import Bugsnag from "@bugsnag/js";
import { client } from "@nju/http-client";
import { isError } from "@nju/result";
import { IRegisterCreditCardResult } from "./types";
import { serverResponse } from "./validators";

interface IParams {
  userId: string;
}

export async function registerCreditCard({
  userId,
}: IParams): Promise<IRegisterCreditCardResult> {
  const data = {
    type: "REGISTER",
    channel: {
      id: "WEB",
      name: "WEB",
    },
    beneficiary: {
      id: userId,
    },
    payer: {
      id: userId,
    },
    paymentMethod: {
      mode: "PRIMARY",
      methodType: "CREDIT_CARD",
      action: "REGISTER",
    },
  };

  const result = await client(
    `${process.env.NEXT_PUBLIC_PUBLIC_GATEWAY_HOST || "unknown"}/payment`,
    {
      method: "post",
      validator: serverResponse,
      json: data,
      headers: {
        version: "2",
        apikey: process.env.NEXT_PUBLIC_APIKEY || "unknown",
      },
    },
  );

  if (isError(result)) {
    Bugsnag.notify(result.err);
    return result;
  }

  return result;
}
